/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementListEventForSelectResponse } from './EventManagementListEventForSelectResponse';

export type EventManagementListEventForSelectResponseApiRespoonse = {
    data?: EventManagementListEventForSelectResponse;
    status?: EventManagementListEventForSelectResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementListEventForSelectResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

